export const IDLE = "idle"; // idle
export const LA_UP = "laup"; // left arm up
export const RA_UP = "raup"; // right arm up
export const BA_UP = "baup"; // both arms up
export const HTL = "htl"; // head tilted left
export const HTR = "htr"; // head tilted right
export const NDWN = "ndwn"; // node down (for squats)
